import { computed, type MaybeRefOrGetter, ref, toValue } from 'vue'

import { isFeatureEnabled, onFeatureFlagsReady } from '@/telemetry/featureFlags'
import type { UserRole } from '@/types/UserRoles'

const MANAGER_ROLES: UserRole[] = ['ROOT', 'ADMIN', 'EDITOR']

export function useLocationGroupsAccess(roles: MaybeRefOrGetter<readonly string[]>) {
  const flagsEnabled = ref(false)

  function refreshFlags(): void {
    flagsEnabled.value = isFeatureEnabled('location-groups') && isFeatureEnabled('leaflet-geolocation-exclusions')
  }

  refreshFlags()
  onFeatureFlagsReady(refreshFlags)

  const hasManagerRole = computed(() => toValue(roles).some(role => MANAGER_ROLES.includes(role as UserRole)))
  const canManageLocationGroups = computed(() => flagsEnabled.value && hasManagerRole.value)

  return { flagsEnabled, hasManagerRole, canManageLocationGroups }
}
